import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const faqs = [
  { question: 'KDV nedir ve kim öder?', answer: 'KDV (Katma Değer Vergisi), mal ve hizmet satışları üzerinden alınan bir tüketim vergisidir. Teknik olarak son tüketici öder; işletmeler ise tahsil ettikleri KDV\'yi devlete aktarır.' },
  { question: 'KDV oranları 2026\'da ne kadar?', answer: '2026 yılı itibarıyla genel KDV oranı %20\'dir. Temel gıda, tarım ürünleri gibi bazı kalemlerde %10, ilaç ve konut gibi bazı kalemlerde ise %1 indirimli oran uygulanmaktadır.' },
  { question: 'KDV beyannamesi ne zaman verilir?', answer: 'KDV beyannamesi aylık olarak verilir. Her ayın 26\'sına kadar bir önceki aya ait KDV beyannamesi verilmeli ve tahakkuk eden vergi ödenmelidir.' },
  { question: 'KDV iadesi nasıl alınır?', answer: 'İhracat, indirimli oranlı işlemler veya yatırım teşviki kapsamındaki alımlar nedeniyle oluşan KDV fazlası iade alınabilir. İade süreci GİB\'e başvuru ve belge ibrazı ile yürütülür.' },
  { question: 'Basit usul mükellefler KDV öder mi?', answer: 'Hayır. Basit usul kapsamındaki mükellefler KDV\'den muaf tutulmaktadır. Bu nedenle fatura düzenleyemez ve KDV beyannamesi vermezler.' },
  { question: 'KDV hesaplama formülü nedir?', answer: 'KDV dahil fiyat = Net fiyat × (1 + KDV oranı). KDV tutarı = Net fiyat × KDV oranı. Örnek: 1.000 ₺ net fiyat için %20 KDV = 200 ₺, toplam = 1.200 ₺.' },
];

const examples = [
  { label: 'Genel Oran (%20)', net: 1000, rate: 0.20 },
  { label: 'İndirimli (%10)', net: 1000, rate: 0.10 },
  { label: 'Düşük Oran (%1)', net: 1000, rate: 0.01 },
];

export default function KdvNedirNasilHesaplanirPage() {
  const [netPrice, setNetPrice] = useState(1000);
  const [kdvRate, setKdvRate] = useState(20);
  useEffect(() => { window.scrollTo({ top: 0 }); }, []);

  const kdvAmount = Math.round(netPrice * (kdvRate / 100));
  const total = netPrice + kdvAmount;

  return (
    <div className="min-h-screen bg-white">
      <InfoNavbar />

      <section className="relative pt-20 min-h-[420px] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img src="https://public.readdy.ai/ai/img_res/7f0025abd174088f079291daa437406b.jpg" alt="KDV Nedir Nasıl Hesaplanır" className="w-full h-full object-cover object-top" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0A2540]/92 via-[#0A2540]/75 to-[#0A2540]/40"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 py-16 w-full">
          <nav className="flex items-center gap-2 mb-5" aria-label="breadcrumb">
            <Link to="/" className="text-white/50 text-xs hover:text-white/80 transition-colors">Ana Sayfa</Link>
            <i className="ri-arrow-right-s-line text-white/30 text-xs"></i>
            <span className="text-white/70 text-xs">KDV Nedir? Nasıl Hesaplanır?</span>
          </nav>
          <div className="flex flex-wrap gap-2 mb-5">
            {['2026 Güncel', 'KDV Oranları', 'Nasıl Hesaplanır', 'Örnekler', 'Beyanname'].map((kw) => (
              <span key={kw} className="px-3 py-1 bg-white/10 border border-white/20 text-white/80 text-xs rounded-full">{kw}</span>
            ))}
          </div>
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 max-w-2xl leading-tight">KDV Nedir? Nasıl Hesaplanır?</h1>
          <p className="text-white/70 text-base md:text-lg max-w-xl leading-relaxed mb-8">KDV oranları, hesaplama yöntemleri ve örneklerle 2026 güncel rehber.</p>
          <div className="flex flex-wrap gap-3">
            <a href="#iletisim-cta" onClick={(e) => { e.preventDefault(); document.getElementById('iletisim-cta')?.scrollIntoView({ behavior: 'smooth' }); }} className="px-6 py-3 bg-white text-[#0A2540] text-sm font-semibold rounded-xl hover:-translate-y-0.5 transition-all cursor-pointer whitespace-nowrap">Bilgi Al</a>
            <a href="https://wa.me/905300953230" target="_blank" rel="nofollow noreferrer" className="px-6 py-3 bg-[#25D366] text-white text-sm font-semibold rounded-xl hover:-translate-y-0.5 transition-all cursor-pointer whitespace-nowrap flex items-center gap-2"><i className="ri-whatsapp-line"></i>WhatsApp</a>
          </div>
        </div>
      </section>

      <section className="py-14 bg-white">
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <p className="text-gray-600 text-base leading-relaxed text-center">
            <strong>KDV (Katma Değer Vergisi)</strong>, Türkiye'de mal ve hizmet satışları üzerinden alınan dolaylı bir vergidir. 2026 yılı itibarıyla genel oran %20 olarak uygulanmaktadır. Hesaplama yöntemleri ve örnekler aşağıda açıklanmaktadır. Durumunuza özel bilgi almak için iletişime geçebilirsiniz.
          </p>
        </div>
      </section>

      <section className="py-14 bg-[#F5F7FA]">
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <div className="text-center mb-10">
            <span className="text-xs font-semibold tracking-widest text-[#0A2540]/50 uppercase">Örnekler</span>
            <h2 className="text-2xl md:text-3xl font-bold text-[#0A2540] mt-3">1.000 ₺ için KDV Hesabı</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
            {examples.map((ex, i) => {
              const kdv = Math.round(ex.net * ex.rate);
              const tot = ex.net + kdv;
              return (
                <div key={i} className="bg-white rounded-2xl p-6 border border-gray-100">
                  <h3 className="text-[#0A2540] font-semibold text-sm mb-4">{ex.label}</h3>
                  <div className="space-y-2">
                    <div className="flex justify-between"><span className="text-gray-500 text-xs">Net Fiyat</span><span className="text-[#0A2540] text-sm font-medium">{ex.net.toLocaleString('tr-TR')} ₺</span></div>
                    <div className="flex justify-between"><span className="text-gray-500 text-xs">KDV Tutarı</span><span className="text-orange-600 text-sm font-medium">{kdv.toLocaleString('tr-TR')} ₺</span></div>
                    <div className="border-t border-gray-100 pt-2 flex justify-between"><span className="text-[#0A2540] text-xs font-semibold">Toplam</span><span className="text-[#0A2540] text-sm font-bold">{tot.toLocaleString('tr-TR')} ₺</span></div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-14 bg-white">
        <div className="max-w-3xl mx-auto px-4 md:px-8">
          <div className="text-center mb-8">
            <span className="text-xs font-semibold tracking-widest text-[#0A2540]/50 uppercase">Hesaplama Aracı</span>
            <h2 className="text-2xl font-bold text-[#0A2540] mt-3">KDV Hesaplayıcı</h2>
          </div>
          <div className="bg-[#F5F7FA] rounded-2xl p-8 border border-gray-100">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="text-[#0A2540] text-sm font-medium mb-2 block">Net Fiyat (₺)</label>
                <input type="number" value={netPrice} onChange={(e) => setNetPrice(Number(e.target.value))} min={0} className="w-full bg-white border border-gray-200 text-[#0A2540] rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-[#0A2540]/40 transition-colors" />
              </div>
              <div>
                <label className="text-[#0A2540] text-sm font-medium mb-2 block">KDV Oranı</label>
                <select value={kdvRate} onChange={(e) => setKdvRate(Number(e.target.value))} className="w-full bg-white border border-gray-200 text-[#0A2540] rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-[#0A2540]/40 transition-colors cursor-pointer">
                  <option value={1}>%1 (Düşük Oran)</option>
                  <option value={10}>%10 (İndirimli)</option>
                  <option value={20}>%20 (Genel Oran)</option>
                </select>
              </div>
            </div>
            <div className="grid grid-cols-3 gap-4">
              <div className="bg-white rounded-xl p-4 text-center border border-gray-100">
                <p className="text-xs text-gray-500 mb-1">Net Fiyat</p>
                <p className="text-[#0A2540] font-bold text-lg">{netPrice.toLocaleString('tr-TR')} ₺</p>
              </div>
              <div className="bg-white rounded-xl p-4 text-center border border-gray-100">
                <p className="text-xs text-gray-500 mb-1">KDV Tutarı</p>
                <p className="text-orange-600 font-bold text-lg">{kdvAmount.toLocaleString('tr-TR')} ₺</p>
              </div>
              <div className="bg-white rounded-xl p-4 text-center border border-gray-100">
                <p className="text-xs text-gray-500 mb-1">Toplam</p>
                <p className="text-[#0A2540] font-bold text-lg">{total.toLocaleString('tr-TR')} ₺</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-14 bg-[#F5F7FA]">
        <div className="max-w-3xl mx-auto px-4 md:px-8">
          <div className="text-center mb-10">
            <span className="text-xs font-semibold tracking-widest text-[#0A2540]/50 uppercase">SSS</span>
            <h2 className="text-2xl md:text-3xl font-bold text-[#0A2540] mt-3">Sık Sorulan Sorular</h2>
          </div>
          <FAQAccordion faqs={faqs} />
        </div>
      </section>

      <SoftCTA />
      <div id="iletisim-cta"><ContactCTA /></div>
      <InfoFooter />
      <a href="https://wa.me/905300953230" target="_blank" rel="nofollow noreferrer" className="fixed bottom-6 right-6 z-50 w-14 h-14 flex items-center justify-center bg-[#25D366] text-white rounded-full cursor-pointer hover:scale-110 transition-transform" aria-label="WhatsApp"><i className="ri-whatsapp-line text-2xl"></i></a>
    </div>
  );
}

function FAQAccordion({ faqs }: { faqs: { question: string; answer: string }[] }) {
  const [open, setOpen] = useState<number | null>(null);
  return (
    <div className="space-y-3">
      {faqs.map((faq, i) => (
        <div key={i} className="border border-gray-200 rounded-xl overflow-hidden">
          <button className="w-full flex items-center justify-between px-6 py-4 text-left bg-white hover:bg-[#F5F7FA] transition-colors cursor-pointer" onClick={() => setOpen(open === i ? null : i)}>
            <span className="text-[#0A2540] font-medium text-sm pr-4">{faq.question}</span>
            <div className="w-6 h-6 flex items-center justify-center flex-shrink-0"><i className={`text-[#0A2540] text-base ${open === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i></div>
          </button>
          {open === i && <div className="px-6 py-4 bg-[#F5F7FA] border-t border-gray-100"><p className="text-gray-600 text-sm leading-relaxed">{faq.answer}</p></div>}
        </div>
      ))}
    </div>
  );
}

function SoftCTA() {
  return (
    <section className="py-10 bg-white">
      <div className="max-w-3xl mx-auto px-4 md:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#0A2540]/5 rounded-full mb-4"><i className="ri-information-line text-[#0A2540] text-sm"></i><span className="text-[#0A2540] text-xs font-medium">Bilgilendirme</span></div>
        <p className="text-gray-600 text-sm leading-relaxed">Bu sayfadaki bilgiler genel rehber niteliğindedir. Durumunuza özel bilgi almak için iletişime geçebilirsiniz.</p>
      </div>
    </section>
  );
}

function ContactCTA() {
  const [form, setForm] = useState({ name: '', phone: '', message: '' });
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.name || !form.phone || !form.message || form.message.length > 500) return;
    setStatus('loading');
    try {
      const body = new URLSearchParams({ name: form.name, phone: form.phone, message: form.message });
      const res = await fetch('https://readdy.ai/api/form/d7c144qqofe8vli40s7g', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body.toString() });
      if (res.ok) { setStatus('success'); setForm({ name: '', phone: '', message: '' }); } else setStatus('error');
    } catch { setStatus('error'); }
  };
  return (
    <section className="py-20 bg-[#0A2540]">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="text-xs font-semibold tracking-widest text-[#60A5FA] uppercase">Ücretsiz Danışmanlık</span>
            <h2 className="text-2xl md:text-3xl font-bold text-white mt-3 mb-4">Durumunuza Özel Bilgi Alın</h2>
            <p className="text-white/60 text-sm leading-relaxed mb-6">KDV ve vergi süreçlerinizde yanınızdayız.</p>
            <div className="flex flex-col gap-3">{[{ icon: 'ri-phone-line', text: '0 530 095 32 30' }, { icon: 'ri-mail-line', text: 'info@ozgurcakmak.com.tr' }, { icon: 'ri-time-line', text: 'Pzt–Cum: 09:00–18:00' }].map((item) => (<div key={item.text} className="flex items-center gap-3"><div className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-lg"><i className={`${item.icon} text-white text-sm`}></i></div><span className="text-white/70 text-sm">{item.text}</span></div>))}</div>
          </div>
          <form onSubmit={handleSubmit} data-readdy-form id="kdv-contact-form" className="bg-white/5 border border-white/10 rounded-2xl p-6 flex flex-col gap-4">
            <div><label className="text-white/60 text-xs mb-1.5 block">Ad Soyad</label><input type="text" name="name" value={form.name} onChange={handleChange} required placeholder="Adınız Soyadınız" className="w-full bg-white/10 border border-white/15 text-white placeholder-white/30 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-white/40 transition-colors" /></div>
            <div><label className="text-white/60 text-xs mb-1.5 block">Telefon</label><input type="tel" name="phone" value={form.phone} onChange={handleChange} required placeholder="+90 5XX XXX XX XX" className="w-full bg-white/10 border border-white/15 text-white placeholder-white/30 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-white/40 transition-colors" /></div>
            <div>
              <div className="flex justify-between mb-1.5"><label className="text-white/60 text-xs">Mesajınız</label><span className="text-white/30 text-xs">{form.message.length}/500</span></div>
              <textarea name="message" value={form.message} onChange={handleChange} required maxLength={500} rows={4} placeholder="Danışmak istediğiniz konu..." className="w-full bg-white/10 border border-white/15 text-white placeholder-white/30 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-white/40 transition-colors resize-none"></textarea>
            </div>
            {status === 'success' && <div className="flex items-center gap-2 p-3 bg-emerald-500/20 border border-emerald-500/30 rounded-lg"><i className="ri-checkbox-circle-line text-emerald-400"></i><span className="text-emerald-300 text-sm">Mesajınız iletildi.</span></div>}
            {status === 'error' && <div className="p-3 bg-rose-500/20 border border-rose-500/30 rounded-lg"><span className="text-rose-300 text-sm">Bir hata oluştu.</span></div>}
            <button type="submit" disabled={status === 'loading' || form.message.length > 500} className="w-full py-3 bg-white text-[#0A2540] text-sm font-semibold rounded-lg hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60">{status === 'loading' ? 'Gönderiliyor...' : 'Mesaj Gönder'}</button>
          </form>
        </div>
      </div>
    </section>
  );
}

function InfoNavbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => { const h = () => setScrolled(window.scrollY > 40); window.addEventListener('scroll', h); return () => window.removeEventListener('scroll', h); }, []);
  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white border-b border-gray-100' : 'bg-[#0A2540]'}`}>
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
        <Link to="/" className="flex items-center cursor-pointer"><img src="https://storage.readdy-site.link/project_files/20f355b3-57c6-42af-8f1b-e19ef75cee72/a013bf3f-953f-4147-a966-2d3225ff6ac1_zgr-akmak-logo-3.png?v=001ea3c7f21fa91e8ebb91c8becb8de9" alt="Özgür Çakmak SMMM Logo" className="h-12 w-auto object-contain" /></Link>
        <div className="flex items-center gap-3">
          <Link to="/" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-[#0A2540]' : 'text-white/80'}`}>Ana Sayfa</Link>
          <a href="#iletisim-cta" onClick={(e) => { e.preventDefault(); document.getElementById('iletisim-cta')?.scrollIntoView({ behavior: 'smooth' }); }} className="px-5 py-2 bg-[#0A2540] text-white text-sm font-medium rounded-lg hover:-translate-y-0.5 transition-all whitespace-nowrap cursor-pointer border border-white/20">İletişime Geç</a>
        </div>
      </div>
    </header>
  );
}

function InfoFooter() {
  const links = [{ label: 'Şahıs Şirketi Nasıl Kurulur?', href: '/sahis-sirketi-nasil-kurulur' }, { label: 'Vergi Oranları 2026', href: '/sahis-sirketi-vergi-oranlari' }, { label: 'Limited mi Şahıs mı?', href: '/limited-mi-sahis-mi' }, { label: 'E-Fatura Zorunluluğu', href: '/e-fatura-kimler-icin-zorunlu' }, { label: 'KDV Nedir?', href: '/kdv-nedir-nasil-hesaplanir' }, { label: 'Vergi Borcu Sorgulama', href: '/vergi-borcu-sorgulama' }];
  return (
    <footer className="bg-[#F5F7FA] border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          <div><div className="flex items-center mb-3"><img src="https://storage.readdy-site.link/project_files/20f355b3-57c6-42af-8f1b-e19ef75cee72/a013bf3f-953f-4147-a966-2d3225ff6ac1_zgr-akmak-logo-3.png?v=001ea3c7f21fa91e8ebb91c8becb8de9" alt="Özgür Çakmak SMMM Logo" className="h-10 w-auto object-contain" /></div><p className="text-gray-500 text-sm leading-relaxed">Mali süreçlerinizde güvenilir danışmanlık.</p></div>
          <div><h4 className="text-[#0A2540] font-semibold text-sm mb-3">Bilgi Merkezi</h4><ul className="space-y-2">{links.map((l) => (<li key={l.href}><Link to={l.href} className="text-gray-500 text-xs hover:text-[#0A2540] transition-colors cursor-pointer">{l.label}</Link></li>))}</ul></div>
          <div><h4 className="text-[#0A2540] font-semibold text-sm mb-3">İletişim</h4><div className="space-y-2">{[{ icon: 'ri-phone-line', text: '0 530 095 32 30' }, { icon: 'ri-mail-line', text: 'info@ozgurcakmak.com.tr' }].map((item) => (<div key={item.text} className="flex items-center gap-2"><div className="w-5 h-5 flex items-center justify-center text-gray-400"><i className={`${item.icon} text-sm`}></i></div><span className="text-gray-500 text-sm">{item.text}</span></div>))}</div></div>
        </div>
      </div>
      <div className="border-t border-gray-200 bg-white"><div className="max-w-7xl mx-auto px-4 md:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-2"><p className="text-gray-400 text-xs">© 2026 Akın SMMM. Tüm hakları saklıdır.</p><Link to="/" className="text-gray-400 text-xs hover:text-gray-600 transition-colors cursor-pointer">Ana Sayfaya Dön</Link></div></div>
    </footer>
  );
}
